import type { $Fetch } from 'nitropack';
import type { BFFResponse } from '~/types/BFFResponse';

export default ($fetch: $Fetch) => {
  const getAutocomplete = async (text: string) => $fetch<BFFResponse<{ data: any }[]>>('/addressRecommend/autocomplete', { query: { text } });

  const checkAddressConfidence = async (body: any) => $fetch<BFFResponse<{ features: any[] }>>('/addressRecommend/addressConfidence', { method: 'POST', body });

  return {
    getAutocomplete,
    checkAddressConfidence,
  };
};
